import axios from "axios";

const state = {
    InternetDialog:false,
    InternetItems:{}
};

const getters = {
    getInternetDialog(state) {
    return state.InternetDialog;
  },
  getInternetItems(state){
    return state.InternetItems; 
  }
};

const mutations = {
    setInternetDialog(state, payload) {
    state.InternetDialog = payload;
  },
  setInternetItems(state, payload){
    state.InternetItems = payload;  
  }
};

const actions = {
    loadInternetDetail({commit}, payload){
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/api/InternetValidationRequest?network=${payload.network}&serviceCode=${payload.serviceCode}`)
      .then(res => {
          console.log(res.data)
        if (res.data.status == 0) {
          commit("setInternetDialog", true);
          commit("setInternetItems", res.data);
        }
        else{
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err)
        commit("setSnackbar", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },

  InternetPayment({commit}, payload){
    commit("setInternetDialog", false);
    commit("setLoading", true);
    commit("setSnackbar", false);
    console.log(payload)
    axios
      .post(`https://backoffice.teller.ng/api/InternetVendRequest?customerID=${payload.customerID}&pin=${payload.pin}&network=${payload.network}&serviceCode=${payload.serviceCode}&customerPhone=${payload.phoneNumber}&imei=1234`)
      .then(res => {
          console.log(res.data)
        if (res.data.status == 0) {
          commit("setInternetDialog", false);
          commit("setInternetItems", {});
          //commit("setSnackbar", true);
          //commit("setServerMessage", "Successful")
          payload.route.push({name: "Successful"})
        }
        else{
            commit("setSnackbar", true);
            commit("setInternetDialog", true);
            commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err)
        commit("setSnackbar", true);
        commit("setInternetDialog", true);
        commit("setServerMessage", err.message)
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};








